export default {
  method_unavailable: 'This payment method is not available right now. Choose another one.',
  payment_option_unavailable: "This payment option isn't available right now. Choose another way to pay.",
  online_payment_unavailable: "Online payment isn't available right now. Please try again in a moment.",
  retry_payment_methods: 'Try again',
  payment_not_ready: 'Your payment is still being prepared. Try again in a moment.',
  wallet_total_changed: 'The total for this payment method has changed. Check it and tap the button again.',
  wallet_tap_above: 'Tap the {{method}} button above to pay, or choose another way to pay.',
  wallet_pay_above: 'Use the {{method}} button above',
  element_incomplete: 'Complete your payment details to continue.',
  element_incomplete_card: 'Check your card details and try again.',
  element_incomplete_bank: 'Choose your bank to continue.',
  element_incomplete_sepa_debit: 'Check your IBAN and account holder details to continue.',
};
